(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[957],{

/***/ 7881:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qr/wifi",
      function () {
        return __webpack_require__(5545);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _internal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4699);
/* harmony import */ var _internal_base_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8312);
/* harmony import */ var _internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1651);
/* harmony import */ var _internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4656);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





var ButtonDropdown = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(_a, ref) {
    var items = _a.items, _b = _a.variant, variant = _b === void 0 ? "normal" : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, loadingText = _a.loadingText, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.expandableGroups, expandableGroups = _e === void 0 ? false : _e, _f = _a.expandToViewport, expandToViewport = _f === void 0 ? false : _f, ariaLabel = _a.ariaLabel, children = _a.children, onItemClick = _a.onItemClick, onItemFollow = _a.onItemFollow, props = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, [
        "items",
        "variant",
        "loading",
        "loadingText",
        "disabled",
        "expandableGroups",
        "expandToViewport",
        "ariaLabel",
        "children",
        "onItemClick",
        "onItemFollow"
    ]);
    var baseComponentProps = (0,_internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("ButtonDropdown");
    var baseProps = (0,_internal_base_component__WEBPACK_IMPORTED_MODULE_1__/* .getBaseProps */ .j)(props);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, baseProps, baseComponentProps, {
        ref: ref,
        items: items,
        variant: variant,
        loading: loading,
        loadingText: loadingText,
        disabled: disabled,
        expandableGroups: expandableGroups,
        expandToViewport: expandToViewport,
        ariaLabel: ariaLabel,
        onItemClick: onItemClick,
        onItemFollow: onItemFollow
    }), children);
});
(0,_internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_5__/* .applyDisplayName */ .b)(ButtonDropdown, "ButtonDropdown");
/* harmony default export */ __webpack_exports__["Z"] = (ButtonDropdown); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 5545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/TopNavigation.tsx + 14 modules
var TopNavigation = __webpack_require__(4210);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/breadcrumb-group/index.js + 4 modules
var breadcrumb_group = __webpack_require__(1753);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/app-layout/index.js + 28 modules
var app_layout = __webpack_require__(9618);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/content-layout/index.js + 1 modules
var content_layout = __webpack_require__(1993);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/header/index.js
var header = __webpack_require__(2646);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/link/index.js
var components_link = __webpack_require__(1902);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/space-between/index.js + 2 modules
var space_between = __webpack_require__(1456);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/container/index.js
var container = __webpack_require__(9684);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/form-field/index.js + 5 modules
var form_field = __webpack_require__(575);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/input/index.js
var input = __webpack_require__(6648);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/select/styles.scoped.css
var styles_scoped = __webpack_require__(1042);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/styles.css.js

/* harmony default export */ var styles_css = ({
    "root": "awsui_root_r2vco_1bz5w_93"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown/index.js + 2 modules
var dropdown = __webpack_require__(5730);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown-status/index.js + 3 modules
var dropdown_status = __webpack_require__(5094);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/input/internal.js
var internal = __webpack_require__(6640);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/select/parts/styles.scoped.css
var parts_styles_scoped = __webpack_require__(8224);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/parts/styles.css.js

/* harmony default export */ var parts_styles_css = ({
    "placeholder": "awsui_placeholder_dwuol_agn1m_93",
    "item": "awsui_item_dwuol_agn1m_98",
    "checkbox": "awsui_checkbox_dwuol_agn1m_102",
    "filter": "awsui_filter_dwuol_agn1m_111",
    "trigger": "awsui_trigger_dwuol_agn1m_116",
    "layout-strut": "awsui_layout-strut_dwuol_agn1m_122",
    "list-bottom": "awsui_list-bottom_dwuol_agn1m_128",
    "selected-icon": "awsui_selected-icon_dwuol_agn1m_132",
    "show-label-tag": "awsui_show-label-tag_dwuol_agn1m_136"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/parts/filter.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var Filter = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var filteringType = _a.filteringType, filterProps = (0,tslib_es6/* __rest */._T)(_a, [
        "filteringType"
    ]);
    if (filteringType === "none") {
        return null;
    }
    return /*#__PURE__*/ react.createElement(internal/* default */.Z, (0,tslib_es6/* __assign */.pi)({
        ref: ref,
        type: "visualSearch",
        className: parts_styles_css.filter,
        autoComplete: false,
        disableBrowserAutocorrect: true,
        invalid: false,
        __noBorderRadius: true
    }, filterProps, {
        __nativeAttributes: (0,tslib_es6/* __assign */.pi)({
            "aria-expanded": true,
            "aria-haspopup": true,
            role: "combobox",
            autoCorrect: "off",
            autoCapitalize: "off"
        }, filterProps.__nativeAttributes)
    }));
});
/* harmony default export */ var parts_filter = (Filter); //# sourceMappingURL=filter.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-merge-refs/index.js
var use_merge_refs = __webpack_require__(5912);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/icon/internal.js + 2 modules
var icon_internal = __webpack_require__(776);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/button-trigger/styles.scoped.css
var button_trigger_styles_scoped = __webpack_require__(6288);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/button-trigger/styles.css.js

/* harmony default export */ var button_trigger_styles_css = ({
    "button-trigger": "awsui_button-trigger_18eso_15xui_97",
    "arrow": "awsui_arrow_18eso_15xui_97",
    "has-caret": "awsui_has-caret_18eso_15xui_135",
    "placeholder": "awsui_placeholder_18eso_15xui_138",
    "pressed": "awsui_pressed_18eso_15xui_151",
    "disabled": "awsui_disabled_18eso_15xui_154",
    "in-filtering-token": "awsui_in-filtering-token_18eso_15xui_163",
    "read-only": "awsui_read-only_18eso_15xui_169",
    "invalid": "awsui_invalid_18eso_15xui_186"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/focus-visible/index.js
var focus_visible = __webpack_require__(9297);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/button-trigger/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







var ButtonTrigger = function(_a, ref) {
    var children = _a.children, _b = _a.pressed, pressed = _b === void 0 ? false : _b, _c = _a.hideCaret, hideCaret = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.readOnly, readOnly = _e === void 0 ? false : _e, _f = _a.invalid, invalid = _f === void 0 ? false : _f, inFilteringToken = _a.inFilteringToken, ariaHasPopup = _a.ariaHasPopup, ariaLabel = _a.ariaLabel, ariaLabelledby = _a.ariaLabelledby, ariaDescribedby = _a.ariaDescribedby, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onMouseDown = _a.onMouseDown, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "children",
        "pressed",
        "hideCaret",
        "disabled",
        "readOnly",
        "invalid",
        "inFilteringToken",
        "ariaHasPopup",
        "ariaLabel",
        "ariaLabelledby",
        "ariaDescribedby",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onClick",
        "onFocus",
        "onBlur"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(restProps);
    var focusVisible = (0,focus_visible/* default */.Z)();
    var attributes = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, focusVisible), baseProps), {
        type: "button",
        className: (0,clsx_m/* default */.Z)(button_trigger_styles_css["button-trigger"], baseProps.className, pressed && button_trigger_styles_css.pressed, disabled && button_trigger_styles_css.disabled, invalid && button_trigger_styles_css.invalid, !hideCaret && button_trigger_styles_css["has-caret"], readOnly && button_trigger_styles_css["read-only"], inFilteringToken && button_trigger_styles_css["in-filtering-token"]),
        disabled: disabled || readOnly,
        "aria-expanded": pressed,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        "aria-haspopup": ariaHasPopup !== null && ariaHasPopup !== void 0 ? ariaHasPopup : "listbox",
        onKeyDown: onKeyDown && function(event) {
            return (0,events/* fireKeyboardEvent */.nm)(onKeyDown, event);
        },
        onKeyUp: onKeyUp && function(event) {
            return (0,events/* fireKeyboardEvent */.nm)(onKeyUp, event);
        },
        onMouseDown: onMouseDown && function(event) {
            return (0,events/* fireCancelableEvent */.y1)(onMouseDown, {}, event);
        },
        onClick: onClick && function(event) {
            return (0,events/* fireCancelableEvent */.y1)(onClick, {}, event);
        },
        onFocus: onFocus && function(event) {
            return (0,events/* fireCancelableEvent */.y1)(onFocus, {}, event);
        },
        onBlur: onBlur && function(event) {
            return (0,events/* fireCancelableEvent */.y1)(onBlur, {
                relatedTarget: event.relatedTarget
            }, event);
        }
    });
    if (invalid) {
        attributes["aria-invalid"] = invalid;
    }
    return /*#__PURE__*/ react.createElement("button", (0,tslib_es6/* __assign */.pi)({
        ref: ref
    }, attributes), children, !hideCaret && /*#__PURE__*/ react.createElement("span", {
        className: button_trigger_styles_css.arrow
    }, /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
        name: "caret-down-filled",
        variant: disabled ? "disabled" : "normal"
    })));
};
/* harmony default export */ var button_trigger = (/*#__PURE__*/react.forwardRef(ButtonTrigger)); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/option/index.js + 3 modules
var components_option = __webpack_require__(3999);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-unique-id/index.js
var use_unique_id = __webpack_require__(6081);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/strings/join-strings.js
var join_strings = __webpack_require__(4906);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/parts/trigger.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0








var Trigger = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var ariaLabelledby = _a.ariaLabelledby, ariaDescribedby = _a.ariaDescribedby, controlId = _a.controlId, invalid = _a.invalid, triggerProps = _a.triggerProps, selectedOption = _a.selectedOption, triggerVariant = _a.triggerVariant, inFilteringToken = _a.inFilteringToken, isOpen = _a.isOpen, placeholder = _a.placeholder, disabled = _a.disabled;
    var id = (0,react.useMemo)(function() {
        return controlId !== null && controlId !== void 0 ? controlId : (0,use_unique_id/* generateUniqueId */.l)();
    }, [
        controlId
    ]);
    var triggerContentId = (0,use_unique_id/* generateUniqueId */.l)("trigger-content-");
    var triggerContent = null;
    if (!selectedOption) {
        triggerContent = /*#__PURE__*/ react.createElement("span", {
            "aria-disabled": "true",
            className: (0,clsx_m/* default */.Z)(parts_styles_css.placeholder, parts_styles_css.trigger),
            id: triggerContentId
        }, placeholder);
    } else if (triggerVariant === "option") {
        triggerContent = /*#__PURE__*/ react.createElement(components_option/* default */.Z, {
            id: triggerContentId,
            option: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, selectedOption), {
                disabled: disabled
            }),
            triggerVariant: true
        });
    } else {
        triggerContent = /*#__PURE__*/ react.createElement("span", {
            id: triggerContentId,
            className: parts_styles_css.trigger
        }, selectedOption.label || selectedOption.value);
    }
    var mergedRef = (0,use_merge_refs/* useMergeRefs */.q)(triggerProps.ref, ref);
    return /*#__PURE__*/ react.createElement(button_trigger, (0,tslib_es6/* __assign */.pi)({}, triggerProps, {
        id: id,
        ref: mergedRef,
        pressed: isOpen,
        disabled: disabled,
        invalid: invalid,
        inFilteringToken: inFilteringToken,
        ariaDescribedby: ariaDescribedby,
        ariaLabelledby: (0,join_strings/* joinStrings */.M)(ariaLabelledby, triggerContentId)
    }), triggerContent);
});
/* harmony default export */ var parts_trigger = (Trigger); //# sourceMappingURL=trigger.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/option/utils/flatten-options.js

var flattenOptions = function(options) {
    var parentMap = new Map();
    var flatOptions = options.reduce(function(acc, option) {
        if ("options" in option) {
            var options_1 = option.options, rest_1 = (0,tslib_es6/* __rest */._T)(option, [
                "options"
            ]);
            var parentDropdownOption_1 = {
                type: "parent",
                option: option
            };
            var allOptionsDisabled = options_1.every(function(option) {
                return option.disabled;
            });
            if (option.disabled || allOptionsDisabled) {
                parentDropdownOption_1.disabled = true;
            }
            acc.push(parentDropdownOption_1);
            options_1.forEach(function(child) {
                var childDropdownOption = {
                    type: "child",
                    option: child
                };
                if (rest_1.disabled || child.disabled) {
                    childDropdownOption.disabled = true;
                }
                acc.push(childDropdownOption);
                parentMap.set(childDropdownOption, parentDropdownOption_1);
            });
        } else {
            var dropdownOption = {
                option: option
            };
            if (option.disabled) {
                dropdownOption.disabled = true;
            }
            acc.push(dropdownOption);
        }
        return acc;
    }, []);
    return {
        flatOptions: flatOptions,
        parentMap: parentMap
    };
}; //# sourceMappingURL=flatten-options.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/option/utils/filter-options.js
var searchableFields = [
    "value",
    "label",
    "description",
    "labelTag"
];
var matchesString = function(value, searchText, strictMatching) {
    if (!value) {
        return false;
    }
    var index = value.toLowerCase().indexOf(searchText);
    return strictMatching ? index === 0 : index > -1;
};
var matchesSingleOption = function(dropdownOption, text, strictMatching) {
    var searchText = text.toLowerCase();
    var option = dropdownOption.option;
    var searchStrFields = function(attr) {
        return matchesString(option[attr], searchText, strictMatching);
    };
    var searchTagsFields = function(attr) {
        var _a;
        return (_a = option[attr]) === null || _a === void 0 ? void 0 : _a.some(function(value) {
            return matchesString(value, searchText, strictMatching);
        });
    };
    var searchableTagFields = [
        "tags"
    ];
    if (!strictMatching) {
        searchableTagFields.push("filteringTags");
    }
    return searchableFields.some(searchStrFields) || searchableTagFields.some(searchTagsFields);
};
var filterOptions = function(options, searchText, strictMatching) {
    if (strictMatching === void 0) {
        strictMatching = false;
    }
    if (searchText === "") {
        return options;
    }
    var currentGroup = null;
    var parentMatched = false;
    return options.reduce(function(acc, option) {
        if (option.type === "parent") {
            parentMatched = false;
            currentGroup = option;
            if (matchesSingleOption(option, searchText, strictMatching)) {
                parentMatched = true;
                acc.push(currentGroup);
            }
            return acc;
        }
        if (option.type !== "child") {
            currentGroup = null;
            parentMatched = false;
        }
        if (parentMatched) {
            acc.push(option);
        } else if (matchesSingleOption(option, searchText, strictMatching)) {
            if (currentGroup) {
                acc.push(currentGroup);
                currentGroup = null;
            }
            acc.push(option);
        }
        return acc;
    }, []);
};
var isInteractive = function(option) {
    return !!option && !option.disabled && option.type !== "parent";
};
var isGroupInteractive = function(option) {
    return !!option && !option.disabled;
};
var isGroup = function(option) {
    return !!option && "options" in option;
}; //# sourceMappingURL=filter-options.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/utils/test-indexes.js
var test_indexes = __webpack_require__(9720);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/option/utils/prepare-options.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



function prepareOptions(options, filteringType, filteringText) {
    var _a = flattenOptions(options), flatOptions = _a.flatOptions, parentMap = _a.parentMap;
    var filteredOptions = filteringType !== "auto" ? flatOptions : filterOptions(flatOptions, filteringText);
    (0,test_indexes/* generateTestIndexes */.$)(filteredOptions, parentMap.get.bind(parentMap));
    return {
        filteredOptions: filteredOptions,
        parentMap: parentMap
    };
} //# sourceMappingURL=prepare-options.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/utils/use-highlight-option.js
var use_highlight_option = __webpack_require__(3509);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/utils/use-open-state.js
var use_open_state = __webpack_require__(9190);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/keycode.js
var keycode = __webpack_require__(6221);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/utils/use-keyboard.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var HOME = 36;
var END = 35;
var useMenuKeyboard = function(_a) {
    var moveHighlight = _a.moveHighlight, selectOption = _a.selectOption, goHome = _a.goHome, goEnd = _a.goEnd, closeDropdown = _a.closeDropdown, isSelectingUsingSpace = _a.isSelectingUsingSpace, _b = _a.preventNativeSpace, preventNativeSpace = _b === void 0 ? false : _b;
    return (0,react.useCallback)(function(e) {
        switch(e.detail.keyCode){
            case keycode/* KeyCode.up */.V.up:
                e.preventDefault();
                moveHighlight(-1);
                break;
            case keycode/* KeyCode.down */.V.down:
                e.preventDefault();
                moveHighlight(1);
                break;
            case HOME:
                goHome();
                break;
            case END:
                goEnd();
                break;
            case keycode/* KeyCode.escape */.V.escape:
                closeDropdown();
                break;
            case keycode/* KeyCode.enter */.V.enter:
                e.preventDefault();
                selectOption();
                break;
            case keycode/* KeyCode.space */.V.space:
                if (preventNativeSpace) {
                    e.preventDefault();
                    selectOption();
                    isSelectingUsingSpace.current = true;
                }
        }
    }, [
        moveHighlight,
        selectOption,
        goHome,
        goEnd,
        closeDropdown,
        isSelectingUsingSpace,
        preventNativeSpace
    ]);
};
var useTriggerKeyboard = function(_a) {
    var openDropdown = _a.openDropdown, goHome = _a.goHome;
    return (0,react.useCallback)(function(e) {
        switch(e.detail.keyCode){
            case keycode/* KeyCode.up */.V.up:
            case keycode/* KeyCode.down */.V.down:
                e.preventDefault();
                goHome();
                openDropdown();
                break;
            case keycode/* KeyCode.space */.V.space:
                e.preventDefault();
                openDropdown();
                break;
        }
    }, [
        openDropdown,
        goHome
    ]);
}; //# sourceMappingURL=use-keyboard.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/utils/use-ids.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var getOptionId = function(menuId, index) {
    if (index < 0) {
        return undefined;
    }
    return "".concat(menuId, "-option-").concat(index);
}; //# sourceMappingURL=use-ids.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/utils/connect-options.js
var connectOptionsByValue = function(options, selectedOptions) {
    return (selectedOptions || []).map(function(selectedOption) {
        for(var _i = 0, options_1 = options; _i < options_1.length; _i++){
            var dropdownOption = options_1[_i];
            if (dropdownOption.type !== "parent" && dropdownOption.option.value === selectedOption.value) {
                return dropdownOption;
            }
        }
        return {
            option: selectedOption
        };
    });
};
var findOptionIndex = function(options, option) {
    for(var index = 0; index < options.length; index++){
        var __option = options[index];
        if (__option === option || __option.value === option.value) {
            return index;
        }
    }
    return -1;
}; //# sourceMappingURL=connect-options.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/forward-focus/index.js
var forward_focus = __webpack_require__(9283);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-previous/index.js
var use_previous = __webpack_require__(8518);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/utils/use-select.js











function useSelect(_a) {
    var selectedOptions = _a.selectedOptions, updateSelectedOption = _a.updateSelectedOption, options = _a.options, filteringType = _a.filteringType, onBlur = _a.onBlur, onFocus = _a.onFocus, externalRef = _a.externalRef, keepOpen = _a.keepOpen, fireLoadItems = _a.fireLoadItems, setFilteringValue = _a.setFilteringValue, _b = _a.useInteractiveGroups, useInteractiveGroups = _b === void 0 ? false : _b;
    var interactivityCheck = useInteractiveGroups ? isGroupInteractive : isInteractive;
    var isHighlightable = function(option) {
        return !!option && (useInteractiveGroups || option.type !== "parent");
    };
    var filterRef = (0,react.useRef)(null);
    var triggerRef = (0,react.useRef)(null);
    var menuRef = (0,react.useRef)(null);
    var hasFilter = filteringType !== "none";
    var activeRef = hasFilter ? filterRef : menuRef;
    var isSelectingUsingSpace = (0,react.useRef)(false);
    var __selectedOptions = connectOptionsByValue(options, selectedOptions);
    var __selectedValuesSet = selectedOptions.reduce(function(selectedValuesSet, item) {
        if (item.value) {
            selectedValuesSet.add(item.value);
        }
        return selectedValuesSet;
    }, new Set());
    var _c = (0,use_highlight_option/* useHighlightedOption */.P)({
        options: options,
        isHighlightable: isHighlightable
    }), _d = _c[0], highlightType = _d.highlightType, highlightedOption = _d.highlightedOption, highlightedIndex = _d.highlightedIndex, _e = _c[1], moveHighlightWithKeyboard = _e.moveHighlightWithKeyboard, resetHighlightWithKeyboard = _e.resetHighlightWithKeyboard, setHighlightedIndexWithMouse = _e.setHighlightedIndexWithMouse, highlightOptionWithKeyboard = _e.highlightOptionWithKeyboard, goHomeWithKeyboard = _e.goHomeWithKeyboard, goEndWithKeyboard = _e.goEndWithKeyboard;
    var _f = (0,use_open_state/* useOpenState */.Z)({
        onOpen: function() {
            return fireLoadItems("");
        },
        onClose: function() {
            resetHighlightWithKeyboard();
            setFilteringValue("");
        }
    }), isOpen = _f.isOpen, openDropdown = _f.openDropdown, closeDropdown = _f.closeDropdown, toggleDropdown = _f.toggleDropdown;
    var handleFocus = function() {
        (0,events/* fireNonCancelableEvent */.B4)(onFocus, {});
    };
    var handleBlur = function() {
        (0,events/* fireNonCancelableEvent */.B4)(onBlur, {});
        closeDropdown();
    };
    var hasSelectedOption = __selectedOptions.length > 0;
    var menuId = (0,use_unique_id/* useUniqueId */.L)("option-list");
    var highlightedOptionId = getOptionId(menuId, highlightedIndex);
    var selectOption = function(option) {
        var _a;
        isSelectingUsingSpace.current = false;
        var optionToSelect = option || highlightedOption;
        if (!optionToSelect || !interactivityCheck(optionToSelect)) {
            return;
        }
        updateSelectedOption(optionToSelect.option);
        if (!keepOpen) {
            (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            closeDropdown();
        }
    };
    var activeKeyDownHandler = useMenuKeyboard({
        moveHighlight: moveHighlightWithKeyboard,
        selectOption: selectOption,
        goHome: goHomeWithKeyboard,
        goEnd: goEndWithKeyboard,
        closeDropdown: function() {
            var _a;
            (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            closeDropdown();
        },
        isSelectingUsingSpace: isSelectingUsingSpace,
        preventNativeSpace: !hasFilter
    });
    var triggerKeyDownHandler = useTriggerKeyboard({
        openDropdown: openDropdown,
        goHome: goHomeWithKeyboard
    });
    var getDropdownProps = function() {
        return {
            onFocus: handleFocus,
            onBlur: handleBlur
        };
    };
    var getTriggerProps = function(disabled) {
        if (disabled === void 0) {
            disabled = false;
        }
        var triggerProps = {
            ref: triggerRef,
            onFocus: function() {
                return closeDropdown();
            }
        };
        if (!disabled) {
            triggerProps.onMouseDown = function(event) {
                var _a;
                event.preventDefault(); // prevent current focus from blurring as it immediately closes the dropdown
                if (isOpen) {
                    (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }
                toggleDropdown();
            };
            triggerProps.onKeyDown = triggerKeyDownHandler;
        }
        return triggerProps;
    };
    var getFilterProps = function() {
        var _a;
        if (!hasFilter) {
            return {};
        }
        return {
            ref: filterRef,
            onKeyDown: activeKeyDownHandler,
            onChange: function(event) {
                setFilteringValue(event.detail.value);
                resetHighlightWithKeyboard();
            },
            __onDelayedInput: function(event) {
                fireLoadItems(event.detail.value);
            },
            __nativeAttributes: (_a = {
                "aria-activedescendant": highlightedOptionId
            }, _a["aria-owns"] = menuId, _a["aria-controls"] = menuId, _a)
        };
    };
    var getMenuProps = function() {
        var menuProps = {
            id: menuId,
            ref: menuRef,
            open: isOpen,
            onMouseUp: function(itemIndex) {
                if (itemIndex > -1) {
                    selectOption(options[itemIndex]);
                }
            },
            onMouseMove: function(itemIndex) {
                if (itemIndex > -1) {
                    setHighlightedIndexWithMouse(itemIndex);
                }
            }
        };
        if (!hasFilter) {
            menuProps.onKeyDown = activeKeyDownHandler;
            menuProps.nativeAttributes = {
                "aria-activedescendant": highlightedOptionId
            };
        }
        return menuProps;
    };
    var getGroupState = function(option) {
        var totalSelected = option.options.filter(function(item) {
            return !!item.value && __selectedValuesSet.has(item.value);
        }).length;
        var hasSelected = totalSelected > 0;
        var allSelected = totalSelected === option.options.length;
        return {
            selected: hasSelected && allSelected,
            indeterminate: hasSelected && !allSelected
        };
    };
    var getOptionProps = function(option, index) {
        var _a;
        var _b;
        var highlighted = option === highlightedOption;
        var groupState = isGroup(option.option) ? getGroupState(option.option) : undefined;
        var selected = __selectedOptions.indexOf(option) > -1 || !!(groupState === null || groupState === void 0 ? void 0 : groupState.selected);
        var nextOption = (_b = options[index + 1]) === null || _b === void 0 ? void 0 : _b.option;
        var isNextSelected = !!nextOption && isGroup(nextOption) ? getGroupState(nextOption).selected : __selectedOptions.indexOf(options[index + 1]) > -1;
        var optionProps = (_a = {
            key: index,
            option: option,
            highlighted: highlighted,
            selected: selected,
            isNextSelected: isNextSelected,
            indeterminate: !!(groupState === null || groupState === void 0 ? void 0 : groupState.indeterminate)
        }, _a["data-mouse-target"] = isHighlightable(option) ? index : -1, _a.id = getOptionId(menuId, index), _a);
        return optionProps;
    };
    var prevOpen = (0,use_previous/* usePrevious */.D)(isOpen);
    (0,react.useEffect)(function() {
        // highlight the first selected option, when opening the Select component without filter input
        // keep the focus in the filter input when opening, so that screenreader can recognize the combobox
        if (isOpen && !prevOpen && hasSelectedOption && !hasFilter) {
            setHighlightedIndexWithMouse(options.indexOf(__selectedOptions[0]));
        }
    }, [
        isOpen,
        __selectedOptions,
        hasSelectedOption,
        setHighlightedIndexWithMouse,
        options,
        prevOpen,
        hasFilter
    ]);
    (0,react.useEffect)(function() {
        var _a;
        if (isOpen) {
            // dropdown-fit calculations ensure that the dropdown will fit inside the current
            // viewport, so prevent the browser from trying to scroll it into view (e.g. if
            // scroll-padding-top is set on a parent)
            (_a = activeRef.current) === null || _a === void 0 ? void 0 : _a.focus({
                preventScroll: true
            });
        }
    }, [
        isOpen,
        activeRef
    ]);
    (0,forward_focus/* default */.Z)(externalRef, triggerRef);
    var highlightedGroupSelected = !!highlightedOption && isGroup(highlightedOption.option) && getGroupState(highlightedOption.option).selected;
    var announceSelected = !!highlightedOption && (__selectedOptions.indexOf(highlightedOption) > -1 || highlightedGroupSelected);
    return {
        isOpen: isOpen,
        highlightedOption: highlightedOption,
        highlightedIndex: highlightedIndex,
        highlightType: highlightType,
        getTriggerProps: getTriggerProps,
        getDropdownProps: getDropdownProps,
        getMenuProps: getMenuProps,
        getFilterProps: getFilterProps,
        getOptionProps: getOptionProps,
        highlightOption: highlightOptionWithKeyboard,
        selectOption: selectOption,
        announceSelected: announceSelected
    };
} //# sourceMappingURL=use-select.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/select/utils/check-option-value-field.js
var check_option_value_field = __webpack_require__(7073);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-debounce-callback/index.js + 1 modules
var use_debounce_callback = __webpack_require__(7933);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/utils/use-native-search.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var isChar = function(keyCode) {
    return [
        0,
        keycode/* KeyCode.enter */.V.enter,
        keycode/* KeyCode.space */.V.space,
        keycode/* KeyCode.tab */.V.tab
    ].indexOf(keyCode) === -1;
};
var isRepeatedChar = function(str) {
    return str.split("").every(function(c) {
        return c === str[0];
    });
};
function findMatchingOption(options, searchText, currentHighlight, useInteractiveGroups) {
    var interactivityCheck = useInteractiveGroups ? isGroupInteractive : isInteractive;
    var filter = function(searchText) {
        return filterOptions(options, searchText, true).filter(function(option) {
            return interactivityCheck(option);
        });
    };
    var matchingOptions = filter(searchText);
    if (matchingOptions.length === 1) {
        return matchingOptions[0];
    }
    // Hit the same char over and over, we assume they want to cycle through
    if (currentHighlight && searchText.length > 1 && isRepeatedChar(searchText)) {
        var matchingOptions_1 = filter(searchText[0]);
        if (matchingOptions_1.length > 0) {
            //handling OptionGroups when useInteractiveGroups is set
            var active = isGroup(currentHighlight) ? matchingOptions_1.map(function(_a) {
                var option = _a.option;
                return option;
            }).indexOf(currentHighlight) : matchingOptions_1.map(function(_a) {
                var option = _a.option;
                return option.value;
            }).indexOf(currentHighlight.value);
            // Pick the next thing (if something with this prefix wasn't selected
            // we'll end up with the first option)
            active += 1;
            active = active % matchingOptions_1.length;
            return matchingOptions_1[active];
        }
    }
    // We have multiple things that start with this prefix.  Based on the
    // behavior of native select, this is considered after the repeated case
    if (matchingOptions.length > 0) {
        return matchingOptions[0];
    }
    return null;
}
function useNativeSearch(_a) {
    var isEnabled = _a.isEnabled, options = _a.options, highlightOption = _a.highlightOption, highlightedOption = _a.highlightedOption, useInteractiveGroups = _a.useInteractiveGroups;
    var value = (0,react.useRef)("");
    var delayedResetValue = (0,use_debounce_callback/* useDebounceCallback */.S)(function() {
        return value.current = "";
    }, 500);
    return function(event) {
        if (!isEnabled) {
            return;
        }
        var charCode = event.charCode;
        if (!isChar(charCode)) {
            return;
        }
        delayedResetValue();
        var newValue = value.current + String.fromCharCode(charCode);
        value.current = newValue;
        var nextHighlight = findMatchingOption(options, newValue, highlightedOption, useInteractiveGroups);
        if (nextHighlight) {
            highlightOption(nextHighlight);
        }
    };
} //# sourceMappingURL=use-native-search.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/utils/use-load-items.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var useLoadItems = function(_a) {
    var onLoadItems = _a.onLoadItems, options = _a.options, statusType = _a.statusType;
    var prevFilteringText = (0,react.useRef)(undefined);
    var fireLoadItems = function(filteringText) {
        if (prevFilteringText.current === filteringText) {
            return;
        }
        prevFilteringText.current = filteringText;
        (0,events/* fireNonCancelableEvent */.B4)(onLoadItems, {
            filteringText: filteringText,
            firstPage: true,
            samePage: false
        });
    };
    var handleLoadMore = function() {
        var firstPage = options.length === 0;
        statusType === "pending" && (0,events/* fireNonCancelableEvent */.B4)(onLoadItems, {
            firstPage: firstPage,
            samePage: false,
            filteringText: prevFilteringText.current || ""
        });
    };
    var handleRecoveryClick = function() {
        return (0,events/* fireNonCancelableEvent */.B4)(onLoadItems, {
            firstPage: false,
            samePage: true,
            filteringText: prevFilteringText.current || ""
        });
    };
    return {
        fireLoadItems: fireLoadItems,
        handleLoadMore: handleLoadMore,
        handleRecoveryClick: handleRecoveryClick
    };
}; //# sourceMappingURL=use-load-items.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/select/utils/use-announcement.js + 1 modules
var use_announcement = __webpack_require__(3517);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/context/form-field-context.js
var form_field_context = __webpack_require__(2308);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/index.js + 1 modules
var options_list = __webpack_require__(7906);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/selectable-item/index.js + 1 modules
var selectable_item = __webpack_require__(1120);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-visual-mode/index.js
var use_visual_mode = __webpack_require__(753);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/checkbox-icon/styles.scoped.css
var checkbox_icon_styles_scoped = __webpack_require__(6816);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/checkbox-icon/styles.css.js

/* harmony default export */ var checkbox_icon_styles_css = ({
    "root": "awsui_root_1fn7j_18k9z_93",
    "styled-box": "awsui_styled-box_1fn7j_18k9z_100",
    "styled-box-checked": "awsui_styled-box-checked_1fn7j_18k9z_106",
    "styled-box-indeterminate": "awsui_styled-box-indeterminate_1fn7j_18k9z_106",
    "styled-box-disabled": "awsui_styled-box-disabled_1fn7j_18k9z_110",
    "styled-line": "awsui_styled-line_1fn7j_18k9z_124",
    "styled-line-disabled": "awsui_styled-line-disabled_1fn7j_18k9z_129"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/checkbox-icon/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





// Can't use css variables for svg attributes
var dimensionsByTheme = {
    "default": {
        viewBox: "0 0 14 14",
        indeterminate: "2.5,7 11.5,7",
        checked: "2.5,7 6,10 11,3",
        xy: 0.5,
        r: 1.5,
        size: 13
    },
    refresh: {
        viewBox: "0 0 16 16",
        indeterminate: "3.5,8 12.5,8",
        checked: "3.5,8 7,11 12,4",
        xy: 1,
        r: 2,
        size: 14
    }
};
var CheckboxIcon = function(_a) {
    var _b, _c;
    var checked = _a.checked, indeterminate = _a.indeterminate, _d = _a.disabled, disabled = _d === void 0 ? false : _d, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "checked",
        "indeterminate",
        "disabled"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(restProps);
    var theme = (0,use_visual_mode/* useVisualRefresh */.LV)() ? "refresh" : "default";
    var dimensions = dimensionsByTheme[theme];
    return /*#__PURE__*/ react.createElement("svg", (0,tslib_es6/* __assign */.pi)({
        className: checkbox_icon_styles_css.root,
        viewBox: dimensions.viewBox,
        "aria-hidden": "true",
        focusable: "false"
    }, baseProps), /*#__PURE__*/ react.createElement("rect", {
        className: (0,clsx_m/* default */.Z)(checkbox_icon_styles_css["styled-box"], (_b = {}, _b[checkbox_icon_styles_css["styled-box-checked"]] = checked, _b[checkbox_icon_styles_css["styled-box-indeterminate"]] = indeterminate, _b[checkbox_icon_styles_css["styled-box-disabled"]] = disabled, _b)),
        x: dimensions.xy,
        y: dimensions.xy,
        rx: dimensions.r,
        ry: dimensions.r,
        width: dimensions.size,
        height: dimensions.size
    }), checked || indeterminate ? /*#__PURE__*/ react.createElement("polyline", {
        className: (0,clsx_m/* default */.Z)(checkbox_icon_styles_css["styled-line"], (_c = {}, _c[checkbox_icon_styles_css["styled-line-disabled"]] = disabled, _c)),
        points: indeterminate ? dimensions.indeterminate : dimensions.checked
    }) : null);
};
/* harmony default export */ var checkbox_icon = (CheckboxIcon); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/parts/item.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0








var Item = function(_a, ref) {
    var option = _a.option, highlighted = _a.highlighted, selected = _a.selected, filteringValue = _a.filteringValue, hasCheckbox = _a.hasCheckbox, virtualPosition = _a.virtualPosition, padBottom = _a.padBottom, isNextSelected = _a.isNextSelected, screenReaderContent = _a.screenReaderContent, ariaPosinset = _a.ariaPosinset, ariaSetsize = _a.ariaSetsize, highlightType = _a.highlightType, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "option",
        "highlighted",
        "selected",
        "filteringValue",
        "hasCheckbox",
        "virtualPosition",
        "padBottom",
        "isNextSelected",
        "screenReaderContent",
        "ariaPosinset",
        "ariaSetsize",
        "highlightType"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(restProps);
    var isParent = option.type === "parent";
    var isChild = option.type === "child";
    var wrappedOption = option.option;
    var disabled = option.disabled || wrappedOption.disabled;
    return /*#__PURE__*/ react.createElement(selectable_item/* default */.Z, (0,tslib_es6/* __assign */.pi)({
        ariaSelected: Boolean(selected),
        selected: selected,
        isNextSelected: isNextSelected,
        highlighted: highlighted,
        disabled: option.disabled,
        isParent: isParent,
        isChild: isChild,
        ref: ref,
        virtualPosition: virtualPosition,
        padBottom: padBottom,
        screenReaderContent: screenReaderContent,
        ariaPosinset: ariaPosinset,
        ariaSetsize: ariaSetsize,
        highlightType: highlightType
    }, baseProps), /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(parts_styles_css.item, !isParent && wrappedOption.labelTag && parts_styles_css["show-label-tag"])
    }, hasCheckbox && !isParent && /*#__PURE__*/ react.createElement("div", {
        className: parts_styles_css.checkbox
    }, /*#__PURE__*/ react.createElement(checkbox_icon, {
        checked: selected || false,
        disabled: option.disabled
    })), isParent ? wrappedOption.label || wrappedOption.value : /*#__PURE__*/ react.createElement(components_option/* default */.Z, {
        option: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, wrappedOption), {
            disabled: disabled
        }),
        highlightText: filteringValue
    }), !hasCheckbox && !isParent && selected && /*#__PURE__*/ react.createElement("div", {
        className: parts_styles_css["selected-icon"]
    }, /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
        name: "check"
    }))));
};
/* harmony default export */ var item = (/*#__PURE__*/react.memo(/*#__PURE__*/ react.forwardRef(Item))); //# sourceMappingURL=item.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/parts/multiselect-item.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







var MultiSelectItem = function(_a, ref) {
    var _b;
    var option = _a.option, highlighted = _a.highlighted, selected = _a.selected, filteringValue = _a.filteringValue, hasCheckbox = _a.hasCheckbox, virtualPosition = _a.virtualPosition, padBottom = _a.padBottom, isNextSelected = _a.isNextSelected, indeterminate = _a.indeterminate, screenReaderContent = _a.screenReaderContent, ariaPosinset = _a.ariaPosinset, ariaSetsize = _a.ariaSetsize, highlightType = _a.highlightType, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "option",
        "highlighted",
        "selected",
        "filteringValue",
        "hasCheckbox",
        "virtualPosition",
        "padBottom",
        "isNextSelected",
        "indeterminate",
        "screenReaderContent",
        "ariaPosinset",
        "ariaSetsize",
        "highlightType"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(restProps);
    var isParent = option.type === "parent";
    var isChild = option.type === "child";
    var wrappedOption = option.option;
    var disabled = option.disabled || wrappedOption.disabled;
    var className = (0,clsx_m/* default */.Z)(parts_styles_css.item, (_b = {}, _b[parts_styles_css.disabled] = disabled, _b));
    return /*#__PURE__*/ react.createElement(selectable_item/* default */.Z, (0,tslib_es6/* __assign */.pi)({
        ariaChecked: isParent && indeterminate ? "mixed" : Boolean(selected),
        selected: selected,
        isNextSelected: isNextSelected,
        highlighted: highlighted,
        disabled: disabled,
        isParent: isParent,
        isChild: isChild,
        highlightType: highlightType,
        ref: ref,
        virtualPosition: virtualPosition,
        padBottom: padBottom,
        useInteractiveGroups: true,
        screenReaderContent: screenReaderContent,
        ariaPosinset: ariaPosinset,
        ariaSetsize: ariaSetsize
    }, baseProps), /*#__PURE__*/ react.createElement("div", {
        className: className
    }, hasCheckbox && /*#__PURE__*/ react.createElement("div", {
        className: parts_styles_css.checkbox
    }, /*#__PURE__*/ react.createElement(checkbox_icon, {
        checked: selected,
        indeterminate: isParent && indeterminate,
        disabled: option.disabled
    })), /*#__PURE__*/ react.createElement(components_option/* default */.Z, {
        option: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, wrappedOption), {
            disabled: disabled
        }),
        highlightText: filteringValue,
        isGroupOption: isParent
    })));
};
/* harmony default export */ var multiselect_item = (/*#__PURE__*/react.memo(/*#__PURE__*/ react.forwardRef(MultiSelectItem))); //# sourceMappingURL=multiselect-item.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/utils/get-item-props.js


var getItemProps = function(_a) {
    var _b;
    var option = _a.option, index = _a.index, getOptionProps = _a.getOptionProps, filteringValue = _a.filteringValue, _c = _a.checkboxes, checkboxes = _c === void 0 ? false : _c;
    var optionProps = getOptionProps(option, index);
    optionProps.filteringValue = filteringValue;
    var _d = (0,test_indexes/* getTestOptionIndexes */.w)(option) || {}, inGroupIndex = _d.inGroupIndex, groupIndex = _d.groupIndex, throughIndex = _d.throughIndex;
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, optionProps), (_b = {
        hasCheckbox: checkboxes
    }, _b["data-group-index"] = groupIndex, _b["data-child-index"] = inGroupIndex, _b["data-test-index"] = throughIndex, _b));
}; //# sourceMappingURL=get-item-props.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/utils/render-options.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var renderOptions = function(_a) {
    var options = _a.options, getOptionProps = _a.getOptionProps, filteringValue = _a.filteringValue, highlightType = _a.highlightType, _b = _a.checkboxes, checkboxes = _b === void 0 ? false : _b, hasDropdownStatus = _a.hasDropdownStatus, virtualItems = _a.virtualItems, useInteractiveGroups = _a.useInteractiveGroups, screenReaderContent = _a.screenReaderContent, ariaSetsize = _a.ariaSetsize;
    return options.map(function(option, index) {
        var virtualItem = virtualItems && virtualItems[index];
        var globalIndex = virtualItem ? virtualItem.index : index;
        var props = getItemProps({
            option: option,
            index: globalIndex,
            getOptionProps: getOptionProps,
            filteringValue: filteringValue,
            checkboxes: checkboxes
        });
        var isLastItem = index === options.length - 1;
        var padBottom = !hasDropdownStatus && isLastItem;
        var ListItem = useInteractiveGroups ? multiselect_item : item;
        return /*#__PURE__*/ react.createElement(ListItem, (0,tslib_es6/* __assign */.pi)({
            key: globalIndex
        }, props, {
            virtualPosition: virtualItem && virtualItem.start,
            ref: virtualItem && virtualItem.measureRef,
            padBottom: padBottom,
            screenReaderContent: screenReaderContent,
            ariaPosinset: globalIndex + 1,
            ariaSetsize: ariaSetsize,
            highlightType: highlightType
        }));
    });
}; //# sourceMappingURL=render-options.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/scrollable-containers.js
var scrollable_containers = __webpack_require__(764);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/parts/plain-list.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





var PlainList = function(_a, ref) {
    var menuProps = _a.menuProps, getOptionProps = _a.getOptionProps, filteredOptions = _a.filteredOptions, filteringValue = _a.filteringValue, highlightType = _a.highlightType, checkboxes = _a.checkboxes, hasDropdownStatus = _a.hasDropdownStatus, listBottom = _a.listBottom, useInteractiveGroups = _a.useInteractiveGroups, screenReaderContent = _a.screenReaderContent;
    var menuRef = menuProps.ref;
    (0,react.useImperativeHandle)(ref, function() {
        return function(index) {
            var _a;
            var item = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[data-mouse-target="'.concat(index, '"]'));
            if (highlightType === "keyboard" && item) {
                (0,scrollable_containers/* scrollElementIntoView */.bx)(item);
            }
        };
    }, [
        highlightType,
        menuRef
    ]);
    return /*#__PURE__*/ react.createElement(options_list/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, menuProps), renderOptions({
        options: filteredOptions,
        getOptionProps: getOptionProps,
        filteringValue: filteringValue,
        highlightType: highlightType,
        checkboxes: checkboxes,
        hasDropdownStatus: hasDropdownStatus,
        useInteractiveGroups: useInteractiveGroups,
        screenReaderContent: screenReaderContent
    }), listBottom ? /*#__PURE__*/ react.createElement("li", {
        role: "option",
        className: parts_styles_css["list-bottom"]
    }, listBottom) : null);
};
/* harmony default export */ var plain_list = (/*#__PURE__*/(0,react.forwardRef)(PlainList)); //# sourceMappingURL=plain-list.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/node_modules/react-virtual/dist/react-virtual.mjs
var react_virtual = __webpack_require__(6427);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/container-queries/use-container-query.js
var use_container_query = __webpack_require__(5382);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/parts/virtual-list.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







var VirtualList = function(props, ref) {
    return props.menuProps.open ? /*#__PURE__*/ react.createElement(VirtualListOpen, (0,tslib_es6/* __assign */.pi)({}, props, {
        ref: ref
    })) : /*#__PURE__*/ react.createElement(VirtualListClosed, (0,tslib_es6/* __assign */.pi)({}, props, {
        ref: ref
    }));
};
var VirtualListOpen = /*#__PURE__*/ (0,react.forwardRef)(function(_a, ref) {
    var menuProps = _a.menuProps, getOptionProps = _a.getOptionProps, filteredOptions = _a.filteredOptions, filteringValue = _a.filteringValue, highlightType = _a.highlightType, checkboxes = _a.checkboxes, hasDropdownStatus = _a.hasDropdownStatus, listBottom = _a.listBottom, useInteractiveGroups = _a.useInteractiveGroups, screenReaderContent = _a.screenReaderContent;
    // update component, when it gets wider or narrower to reposition items
    var _b = (0,use_container_query/* useContainerQuery */.D)(function(rect) {
        return rect.width;
    }, []), width = _b[0], menuMeasureRef = _b[1];
    var menuRefObject = (0,react.useRef)(null);
    var menuRef = (0,use_merge_refs/* useMergeRefs */.q)(menuMeasureRef, menuRefObject, menuProps.ref);
    var _c = (0,react_virtual/* useVirtual */.o)({
        size: filteredOptions.length,
        parentRef: menuRefObject,
        // estimateSize is a dependency of measurements memo. We update it to force full recalculation
        // when the height of any option could have changed:
        // 1: because the component got resized (width property got updated)
        // 2: because the option changed its content (filteringValue property controls the highlight and the visibility of hidden tags)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        estimateSize: (0,react.useCallback)(function() {
            return 31;
        }, [
            width,
            filteringValue
        ]),
        overscan: 5
    }), virtualItems = _c.virtualItems, totalSize = _c.totalSize, scrollToIndex = _c.scrollToIndex;
    (0,react.useImperativeHandle)(ref, function() {
        return function(index) {
            if (highlightType === "keyboard") {
                scrollToIndex(index);
            }
        };
    }, [
        highlightType,
        scrollToIndex
    ]);
    var finalOptions = renderOptions({
        options: virtualItems.map(function(_a) {
            var index = _a.index;
            return filteredOptions[index];
        }),
        getOptionProps: getOptionProps,
        filteringValue: filteringValue,
        highlightType: highlightType,
        checkboxes: checkboxes,
        hasDropdownStatus: hasDropdownStatus,
        virtualItems: virtualItems,
        useInteractiveGroups: useInteractiveGroups,
        screenReaderContent: screenReaderContent,
        ariaSetsize: filteredOptions.length
    });
    return /*#__PURE__*/ react.createElement(options_list/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, menuProps, {
        ref: menuRef
    }), /*#__PURE__*/ react.createElement("div", {
        "aria-hidden": "true",
        key: "total-size",
        className: parts_styles_css["layout-strut"],
        style: {
            height: totalSize
        }
    }), finalOptions, listBottom ? /*#__PURE__*/ react.createElement("li", {
        role: "option",
        className: parts_styles_css["list-bottom"]
    }, listBottom) : null);
});
var VirtualListClosed = /*#__PURE__*/ (0,react.forwardRef)(function(_a, ref) {
    var menuProps = _a.menuProps, listBottom = _a.listBottom;
    (0,react.useImperativeHandle)(ref, function() {
        return function() {};
    }, []);
    return /*#__PURE__*/ react.createElement(options_list/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, menuProps, {
        ref: menuProps.ref
    }), listBottom ? /*#__PURE__*/ react.createElement("li", {
        role: "option",
        className: parts_styles_css["list-bottom"]
    }, listBottom) : null);
});
/* harmony default export */ var virtual_list = (/*#__PURE__*/(0,react.forwardRef)(VirtualList)); //# sourceMappingURL=virtual-list.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown-footer/index.js + 1 modules
var dropdown_footer = __webpack_require__(1550);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/check-controlled/index.js
var check_controlled = __webpack_require__(3686);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/screenreader-only/index.js + 1 modules
var screenreader_only = __webpack_require__(1304);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
























var InternalSelect = /*#__PURE__*/ react.forwardRef(function(_a, externalRef) {
    var _b;
    var options = _a.options, _c = _a.filteringType, filteringType = _c === void 0 ? "none" : _c, filteringPlaceholder = _a.filteringPlaceholder, filteringAriaLabel = _a.filteringAriaLabel, ariaRequired = _a.ariaRequired, placeholder = _a.placeholder, disabled = _a.disabled, ariaLabel = _a.ariaLabel, _d = _a.statusType, statusType = _d === void 0 ? "finished" : _d, empty = _a.empty, loadingText = _a.loadingText, finishedText = _a.finishedText, errorText = _a.errorText, recoveryText = _a.recoveryText, noMatch = _a.noMatch, _e = _a.triggerVariant, triggerVariant = _e === void 0 ? "label" : _e, selectedAriaLabel = _a.selectedAriaLabel, renderHighlightedAriaLive = _a.renderHighlightedAriaLive, selectedOption = _a.selectedOption, onBlur = _a.onBlur, onFocus = _a.onFocus, onLoadItems = _a.onLoadItems, onChange = _a.onChange, virtualScroll = _a.virtualScroll, expandToViewport = _a.expandToViewport, __inFilteringToken = _a.__inFilteringToken, _f = _a.__internalRootRef, __internalRootRef = _f === void 0 ? null : _f, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "options",
        "filteringType",
        "filteringPlaceholder",
        "filteringAriaLabel",
        "ariaRequired",
        "placeholder",
        "disabled",
        "ariaLabel",
        "statusType",
        "empty",
        "loadingText",
        "finishedText",
        "errorText",
        "recoveryText",
        "noMatch",
        "triggerVariant",
        "selectedAriaLabel",
        "renderHighlightedAriaLive",
        "selectedOption",
        "onBlur",
        "onFocus",
        "onLoadItems",
        "onChange",
        "virtualScroll",
        "expandToViewport",
        "__inFilteringToken",
        "__internalRootRef"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(restProps);
    var formFieldContext = (0,form_field_context/* useFormFieldContext */.e)(restProps);
    var _g = useLoadItems({
        onLoadItems: onLoadItems,
        options: options,
        statusType: statusType
    }), handleLoadMore = _g.handleLoadMore, handleRecoveryClick = _g.handleRecoveryClick, fireLoadItems = _g.fireLoadItems;
    (0,check_controlled/* default */.Z)("Select", "selectedOption", selectedOption, "onChange", onChange);
    (0,check_option_value_field/* checkOptionValueField */.N)("Select", "options", options);
    var _h = (0,react.useState)(""), filteringValue = _h[0], setFilteringValue = _h[1];
    var _j = prepareOptions(options, filteringType, filteringValue), filteredOptions = _j.filteredOptions, parentMap = _j.parentMap;
    var rootRef = (0,react.useRef)(null);
    var triggerRef = (0,react.useRef)(null);
    var selfControlId = (0,use_unique_id/* useUniqueId */.L)("trigger");
    var controlId = (_b = formFieldContext.controlId) !== null && _b !== void 0 ? _b : selfControlId;
    var scrollToIndex = (0,react.useRef)(null);
    var _k = useSelect({
        selectedOptions: selectedOption ? [
            selectedOption
        ] : [],
        updateSelectedOption: function(option) {
            return (0,events/* fireNonCancelableEvent */.B4)(onChange, {
                selectedOption: option
            });
        },
        options: filteredOptions,
        filteringType: filteringType,
        onBlur: onBlur,
        onFocus: onFocus,
        externalRef: externalRef,
        fireLoadItems: fireLoadItems,
        setFilteringValue: setFilteringValue
    }), isOpen = _k.isOpen, highlightType = _k.highlightType, highlightedOption = _k.highlightedOption, highlightedIndex = _k.highlightedIndex, getTriggerProps = _k.getTriggerProps, getDropdownProps = _k.getDropdownProps, getFilterProps = _k.getFilterProps, getMenuProps = _k.getMenuProps, getOptionProps = _k.getOptionProps, highlightOption = _k.highlightOption, selectOption = _k.selectOption, announceSelected = _k.announceSelected;
    var handleNativeSearch = useNativeSearch({
        isEnabled: filteringType === "none",
        options: filteredOptions,
        highlightOption: !isOpen ? selectOption : highlightOption,
        highlightedOption: !isOpen ? selectedOption : highlightedOption === null || highlightedOption === void 0 ? void 0 : highlightedOption.option
    });
    var selectAriaLabelId = (0,use_unique_id/* useUniqueId */.L)("select-arialabel-");
    (0,react.useEffect)(function() {
        var _a;
        (_a = scrollToIndex.current) === null || _a === void 0 ? void 0 : _a.call(scrollToIndex, highlightedIndex);
    }, [
        highlightedIndex
    ]);
    var filter = /*#__PURE__*/ react.createElement(parts_filter, (0,tslib_es6/* __assign */.pi)({
        filteringType: filteringType,
        placeholder: filteringPlaceholder,
        ariaLabel: filteringAriaLabel,
        ariaRequired: ariaRequired,
        value: filteringValue
    }, getFilterProps()));
    var trigger = /*#__PURE__*/ react.createElement(parts_trigger, (0,tslib_es6/* __assign */.pi)({
        ref: triggerRef,
        placeholder: placeholder,
        disabled: disabled,
        triggerVariant: triggerVariant,
        triggerProps: getTriggerProps(disabled),
        selectedOption: selectedOption,
        isOpen: isOpen,
        inFilteringToken: __inFilteringToken
    }, formFieldContext, {
        controlId: controlId,
        ariaLabelledby: (0,join_strings/* joinStrings */.M)(formFieldContext.ariaLabelledby, selectAriaLabelId)
    }));
    var menuProps = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, getMenuProps()), {
        onLoadMore: handleLoadMore,
        ariaLabelledby: (0,join_strings/* joinStrings */.M)(selectAriaLabelId, controlId)
    });
    var isEmpty = !options || options.length === 0;
    var isNoMatch = filteredOptions && filteredOptions.length === 0;
    var dropdownStatus = (0,dropdown_status/* useDropdownStatus */.w)({
        statusType: statusType,
        empty: empty,
        loadingText: loadingText,
        finishedText: finishedText,
        errorText: errorText,
        recoveryText: recoveryText,
        isEmpty: isEmpty,
        isNoMatch: isNoMatch,
        noMatch: noMatch,
        onRecoveryClick: handleRecoveryClick
    });
    var announcement = (0,use_announcement/* useAnnouncement */.q)({
        announceSelected: announceSelected,
        highlightedOption: highlightedOption,
        getParent: function(option) {
            var _a;
            return (_a = parentMap.get(option)) === null || _a === void 0 ? void 0 : _a.option;
        },
        selectedAriaLabel: selectedAriaLabel,
        renderHighlightedAriaLive: renderHighlightedAriaLive
    });
    var ListComponent = virtualScroll ? virtual_list : plain_list;
    var handleMouseDown = function(event) {
        var target = event.target;
        if (target !== document.activeElement) {
            // prevent currently focused element from losing it
            event.preventDefault();
        }
    };
    var mergedRef = (0,use_merge_refs/* useMergeRefs */.q)(rootRef, __internalRootRef);
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        ref: mergedRef,
        className: (0,clsx_m/* default */.Z)(styles_css.root, baseProps.className),
        onKeyPress: handleNativeSearch
    }), /*#__PURE__*/ react.createElement(dropdown/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, getDropdownProps(), {
        open: isOpen,
        stretchTriggerHeight: __inFilteringToken,
        trigger: trigger,
        header: filter,
        onMouseDown: handleMouseDown,
        footer: dropdownStatus.isSticky ? /*#__PURE__*/ react.createElement(dropdown_footer/* default */.Z, {
            content: dropdownStatus.content
        }) : null,
        expandToViewport: expandToViewport
    }), /*#__PURE__*/ react.createElement(ListComponent, {
        listBottom: !dropdownStatus.isSticky ? /*#__PURE__*/ react.createElement(dropdown_footer/* default */.Z, {
            content: dropdownStatus.content
        }) : null,
        menuProps: menuProps,
        getOptionProps: getOptionProps,
        filteredOptions: filteredOptions,
        filteringValue: filteringValue,
        ref: scrollToIndex,
        hasDropdownStatus: dropdownStatus.content !== null,
        screenReaderContent: announcement,
        highlightType: highlightType
    })), /*#__PURE__*/ react.createElement(screenreader_only/* default */.Z, {
        id: selectAriaLabelId
    }, ariaLabel));
});
/* harmony default export */ var select_internal = (InternalSelect); //# sourceMappingURL=internal.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/external-props.js
var external_props = __webpack_require__(6464);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





var Select = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.filteringType, filteringType = _c === void 0 ? "none" : _c, _d = _a.statusType, statusType = _d === void 0 ? "finished" : _d, _e = _a.triggerVariant, triggerVariant = _e === void 0 ? "label" : _e, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "options",
        "filteringType",
        "statusType",
        "triggerVariant"
    ]);
    var baseComponentProps = (0,use_base_component/* default */.Z)("Select");
    var externalProps = (0,external_props/* getExternalProps */.x)(restProps);
    return /*#__PURE__*/ react.createElement(select_internal, (0,tslib_es6/* __assign */.pi)({
        options: options,
        filteringType: filteringType,
        statusType: statusType,
        triggerVariant: triggerVariant
    }, externalProps, baseComponentProps, {
        ref: ref
    }));
});
(0,apply_display_name/* applyDisplayName */.b)(Select, "Select");
/* harmony default export */ var components_select = (Select); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/abstract-switch/index.js + 1 modules
var abstract_switch = __webpack_require__(7230);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/toggle/styles.scoped.css
var toggle_styles_scoped = __webpack_require__(2929);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/toggle/styles.css.js

/* harmony default export */ var toggle_styles_css = ({
    "root": "awsui_root_4yi2u_sykyg_93",
    "outline": "awsui_outline_4yi2u_sykyg_105",
    "toggle-control": "awsui_toggle-control_4yi2u_sykyg_124",
    "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_sykyg_133",
    "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_sykyg_136",
    "toggle-handle": "awsui_toggle-handle_4yi2u_sykyg_143",
    "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_sykyg_155",
    "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_sykyg_158"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/toggle/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0








var InternalToggle = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var _b, _c;
    var controlId = _a.controlId, checked = _a.checked, name = _a.name, disabled = _a.disabled, children = _a.children, description = _a.description, ariaLabel = _a.ariaLabel, onFocus = _a.onFocus, onBlur = _a.onBlur, onChange = _a.onChange, _d = _a.__internalRootRef, __internalRootRef = _d === void 0 ? null : _d, rest = (0,tslib_es6/* __rest */._T)(_a, [
        "controlId",
        "checked",
        "name",
        "disabled",
        "children",
        "description",
        "ariaLabel",
        "onFocus",
        "onBlur",
        "onChange",
        "__internalRootRef"
    ]);
    var _e = (0,form_field_context/* useFormFieldContext */.e)(rest), ariaDescribedby = _e.ariaDescribedby, ariaLabelledby = _e.ariaLabelledby;
    var baseProps = (0,base_component/* getBaseProps */.j)(rest);
    var checkboxRef = (0,react.useRef)(null);
    (0,forward_focus/* default */.Z)(ref, checkboxRef);
    return /*#__PURE__*/ react.createElement(abstract_switch/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(toggle_styles_css.root, baseProps.className),
        controlClassName: (0,clsx_m/* default */.Z)(toggle_styles_css["toggle-control"], (_b = {}, _b[toggle_styles_css["toggle-control-checked"]] = checked, _b[toggle_styles_css["toggle-control-disabled"]] = disabled, _b)),
        outlineClassName: toggle_styles_css.outline,
        controlId: controlId,
        disabled: disabled,
        label: children,
        description: description,
        descriptionBottomPadding: true,
        ariaLabel: ariaLabel,
        ariaLabelledby: ariaLabelledby,
        ariaDescribedby: ariaDescribedby,
        nativeControl: function(nativeControlProps) {
            return /*#__PURE__*/ react.createElement("input", (0,tslib_es6/* __assign */.pi)({}, nativeControlProps, {
                ref: checkboxRef,
                type: "checkbox",
                checked: checked,
                name: name,
                onFocus: function() {
                    return (0,events/* fireNonCancelableEvent */.B4)(onFocus);
                },
                onBlur: function() {
                    return (0,events/* fireNonCancelableEvent */.B4)(onBlur);
                },
                // empty handler to suppress React controllability warning
                onChange: function() {}
            }));
        },
        onClick: function() {
            var _a;
            (_a = checkboxRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            (0,events/* fireNonCancelableEvent */.B4)(onChange, {
                checked: !checked
            });
        },
        styledControl: /*Using span, not div for HTML validity*/ /*#__PURE__*/ react.createElement("span", {
            className: (0,clsx_m/* default */.Z)(toggle_styles_css["toggle-handle"], (_c = {}, _c[toggle_styles_css["toggle-handle-checked"]] = checked, _c[toggle_styles_css["toggle-handle-disabled"]] = disabled, _c))
        }),
        __internalRootRef: __internalRootRef
    }));
});
/* harmony default export */ var toggle_internal = (InternalToggle); //# sourceMappingURL=internal.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/toggle/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var Toggle = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var baseComponentProps = (0,use_base_component/* default */.Z)("Toggle");
    return /*#__PURE__*/ react.createElement(toggle_internal, (0,tslib_es6/* __assign */.pi)({}, props, baseComponentProps, {
        ref: ref
    }));
});
(0,apply_display_name/* applyDisplayName */.b)(Toggle, "Toggle");
/* harmony default export */ var toggle = (Toggle); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button/index.js
var components_button = __webpack_require__(7140);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/text-content/index.js + 1 modules
var text_content = __webpack_require__(3046);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/button-dropdown/index.js
var button_dropdown = __webpack_require__(4977);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/textarea/index.js + 1 modules
var components_textarea = __webpack_require__(5546);
// EXTERNAL MODULE: ./components/Navigation.tsx + 21 modules
var Navigation = __webpack_require__(5794);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-qr-code/lib/index.js
var lib = __webpack_require__(1653);
;// CONCATENATED MODULE: ./pages/qr/wifi.tsx







var CopyStatus;
(function(CopyStatus) {
    CopyStatus["READY"] = "Copy";
    CopyStatus["COPYING"] = "Copying";
    CopyStatus["COPIED"] = "Copied";
})(CopyStatus || (CopyStatus = {}));
function Breadcrumbs() {
    const breadcrumbItems = [
        {
            text: "Home",
            href: "/"
        },
        {
            text: "QR Code Tools",
            href: "/qr"
        },
        {
            text: "Wi-Fi QR Code Generator",
            href: "/qr/wifi"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_group/* default */.Z, {
        items: breadcrumbItems,
        expandAriaLabel: "Show path",
        ariaLabel: "Breadcrumbs"
    });
}
const wifiSecurityOptions = [
    {
        label: "WPA/WPA2/WPA3",
        value: "WPA"
    },
    {
        label: "WEP",
        value: "WEP"
    },
    {
        label: "None",
        value: "none"
    }
];
const wifiToString = (ssid, security, password, hidden)=>{
    return "WIFI:S:".concat(ssid, ";T:").concat(security, ";P:").concat(password !== null && password !== void 0 ? password : "", ";").concat(hidden ? "".concat(hidden) : "", ";");
};
var __N_SSP = true;
function Page() {
    const router = (0,next_router.useRouter)();
    const [networkName, setNetworkName] = (0,react.useState)("");
    const [securityMode, setSecurityMode] = (0,react.useState)(wifiSecurityOptions[0]);
    const [password, setPassword] = (0,react.useState)("");
    const [hidden, setHidden] = (0,react.useState)(false);
    // const [result, setResult] = useState("");
    const [processing, setProcessing] = (0,react.useState)(false);
    const [error, setError] = (0,react.useState)("");
    // const setValueDebounce = debounce((data) => {
    //   const value = wifiToString(networkName, securityMode.value ?? "", password);
    //   setValue(value);
    // }, 500);
    const result = (0,react.useMemo)(()=>{
        var _value;
        const qrCodeString = wifiToString(networkName, (_value = securityMode.value) !== null && _value !== void 0 ? _value : "", password, hidden);
        setProcessing(false);
        return qrCodeString;
    }, [
        networkName,
        securityMode.value,
        password,
        hidden
    ]);
    const [copyStatus, setCopyStatus] = (0,react.useState)(CopyStatus.READY);
    const onCopyClicked = (0,react.useCallback)((text)=>{
        setCopyStatus(CopyStatus.COPYING);
        navigator.clipboard.writeText(text);
        setTimeout(()=>{
            setCopyStatus(CopyStatus.COPIED);
        }, 200);
        setTimeout(()=>{
            setCopyStatus(CopyStatus.READY);
        }, 1000);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopNavigation/* TopNav */.t, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(app_layout/* default */.Z, {
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(content_layout/* default */.Z, {
                    header: /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                        variant: "h1",
                        info: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* default */.Z, {
                            variant: "info",
                            ariaLabel: "Information about text converter."
                        }),
                        children: "Wi-Fi QR Code Generator"
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(space_between/* default */.Z, {
                        size: "m",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(space_between/* default */.Z, {
                                size: "m",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(space_between/* default */.Z, {
                                        size: "s",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(space_between/* default */.Z, {
                                                size: "s",
                                                direction: "horizontal",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                                                    variant: "h2",
                                                    children: "Wi-Fi Setup"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_field/* default */.Z, {
                                                label: "Network Name",
                                                description: "Name of the Wi-Fi Network(e.g. FastNet5GHz)",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                    placeholder: "SSID",
                                                    value: networkName,
                                                    onChange: (event)=>{
                                                        setProcessing(true);
                                                        setNetworkName(event.detail.value);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_field/* default */.Z, {
                                                label: "Security Mode",
                                                description: "Choose WPA / WPA2 / WPA3 (recommended) for the best security, or WEP for compatibility",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_select, {
                                                    placeholder: "Wi-Fi Security",
                                                    options: wifiSecurityOptions,
                                                    onChange: (event)=>{
                                                        setProcessing(true);
                                                        var _selectedOption;
                                                        setSecurityMode((_selectedOption = event.detail.selectedOption) !== null && _selectedOption !== void 0 ? _selectedOption : wifiSecurityOptions[0]);
                                                    },
                                                    selectedOption: securityMode
                                                })
                                            }),
                                            securityMode.value !== "none" && /*#__PURE__*/ (0,jsx_runtime.jsx)(form_field/* default */.Z, {
                                                label: "Password",
                                                description: "Wi-Fi Network Password",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                    placeholder: "".concat(securityMode.label, " Password"),
                                                    value: password,
                                                    onChange: (event)=>{
                                                        setProcessing(true);
                                                        setPassword(event.detail.value);
                                                    },
                                                    type: "password"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_field/* default */.Z, {
                                        label: "Hidden Network",
                                        description: "Check this box if the network is hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle, {
                                            onChange: (event)=>setHidden(event.detail.checked),
                                            checked: hidden,
                                            children: "Hidden"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(space_between/* default */.Z, {
                                        size: "s",
                                        direction: "horizontal",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                variant: "primary",
                                                iconName: "multiscreen",
                                                loading: processing,
                                                children: "Convert"
                                            }),
                                            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(text_content/* default */.Z, {
                                                children: error
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(space_between/* default */.Z, {
                                        size: "s",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(space_between/* default */.Z, {
                                                size: "s",
                                                direction: "horizontal",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                                                    variant: "h2",
                                                    children: "Result"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(space_between/* default */.Z, {
                                                size: "s",
                                                direction: "horizontal",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                                        value: result
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(space_between/* default */.Z, {
                                                        size: "s",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dropdown/* default */.Z, {
                                                            items: [
                                                                {
                                                                    text: "Save as PNG",
                                                                    id: "png"
                                                                },
                                                                {
                                                                    text: "Save as JPG",
                                                                    id: "jpg"
                                                                },
                                                                {
                                                                    text: "Save as SVG",
                                                                    id: "svg"
                                                                }
                                                            ],
                                                            children: "Save As"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(space_between/* default */.Z, {
                                                size: "s",
                                                direction: "horizontal",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_textarea/* default */.Z, {
                                                        readOnly: true,
                                                        value: result
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                        iconName: "copy",
                                                        onClick: ()=>onCopyClicked(result),
                                                        loading: copyStatus == CopyStatus.COPYING,
                                                        disabled: copyStatus == CopyStatus.COPIED,
                                                        children: copyStatus
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                }),
                headerSelector: "#header",
                breadcrumbs: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs, {}),
                navigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation/* Navigation */.W, {})
            })
        ]
    });
}


/***/ }),

/***/ 6288:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6816:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8224:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1042:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2929:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6427:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useVirtual; }
/* harmony export */ });
/* unused harmony export defaultRangeExtractor */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var props = ['bottom', 'height', 'left', 'right', 'top', 'width'];

var rectChanged = function rectChanged(a, b) {
  if (a === void 0) {
    a = {};
  }

  if (b === void 0) {
    b = {};
  }

  return props.some(function (prop) {
    return a[prop] !== b[prop];
  });
};

var observedNodes = /*#__PURE__*/new Map();
var rafId;

var run = function run() {
  var changedStates = [];
  observedNodes.forEach(function (state, node) {
    var newRect = node.getBoundingClientRect();

    if (rectChanged(newRect, state.rect)) {
      state.rect = newRect;
      changedStates.push(state);
    }
  });
  changedStates.forEach(function (state) {
    state.callbacks.forEach(function (cb) {
      return cb(state.rect);
    });
  });
  rafId = window.requestAnimationFrame(run);
};

function observeRect(node, cb) {
  return {
    observe: function observe() {
      var wasEmpty = observedNodes.size === 0;

      if (observedNodes.has(node)) {
        observedNodes.get(node).callbacks.push(cb);
      } else {
        observedNodes.set(node, {
          rect: undefined,
          hasRectChanged: false,
          callbacks: [cb]
        });
      }

      if (wasEmpty) run();
    },
    unobserve: function unobserve() {
      var state = observedNodes.get(node);

      if (state) {
        // Remove the callback
        var index = state.callbacks.indexOf(cb);
        if (index >= 0) state.callbacks.splice(index, 1); // Remove the node reference

        if (!state.callbacks.length) observedNodes["delete"](node); // Stop the loop

        if (!observedNodes.size) cancelAnimationFrame(rafId);
      }
    }
  };
}

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;

function useRect(nodeRef, initialRect) {
  if (initialRect === void 0) {
    initialRect = {
      width: 0,
      height: 0
    };
  }

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(nodeRef.current),
      element = _React$useState[0],
      setElement = _React$useState[1];

  var _React$useReducer = react__WEBPACK_IMPORTED_MODULE_0__.useReducer(rectReducer, initialRect),
      rect = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var initialRectSet = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  useIsomorphicLayoutEffect(function () {
    if (nodeRef.current !== element) {
      setElement(nodeRef.current);
    }
  });
  useIsomorphicLayoutEffect(function () {
    if (element && !initialRectSet.current) {
      initialRectSet.current = true;

      var _rect = element.getBoundingClientRect();

      dispatch({
        rect: _rect
      });
    }
  }, [element]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (!element) {
      return;
    }

    var observer = observeRect(element, function (rect) {
      dispatch({
        rect: rect
      });
    });
    observer.observe();
    return function () {
      observer.unobserve();
    };
  }, [element]);
  return rect;
}

function rectReducer(state, action) {
  var rect = action.rect;

  if (state.height !== rect.height || state.width !== rect.width) {
    return rect;
  }

  return state;
}

var defaultEstimateSize = function defaultEstimateSize() {
  return 50;
};

var defaultKeyExtractor = function defaultKeyExtractor(index) {
  return index;
};

var defaultMeasureSize = function defaultMeasureSize(el, horizontal) {
  var key = horizontal ? 'offsetWidth' : 'offsetHeight';
  return el[key];
};

var defaultRangeExtractor = function defaultRangeExtractor(range) {
  var start = Math.max(range.start - range.overscan, 0);
  var end = Math.min(range.end + range.overscan, range.size - 1);
  var arr = [];

  for (var i = start; i <= end; i++) {
    arr.push(i);
  }

  return arr;
};
function useVirtual(_ref) {
  var _measurements;

  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 0 : _ref$size,
      _ref$estimateSize = _ref.estimateSize,
      estimateSize = _ref$estimateSize === void 0 ? defaultEstimateSize : _ref$estimateSize,
      _ref$overscan = _ref.overscan,
      overscan = _ref$overscan === void 0 ? 1 : _ref$overscan,
      _ref$paddingStart = _ref.paddingStart,
      paddingStart = _ref$paddingStart === void 0 ? 0 : _ref$paddingStart,
      _ref$paddingEnd = _ref.paddingEnd,
      paddingEnd = _ref$paddingEnd === void 0 ? 0 : _ref$paddingEnd,
      parentRef = _ref.parentRef,
      horizontal = _ref.horizontal,
      scrollToFn = _ref.scrollToFn,
      useObserver = _ref.useObserver,
      initialRect = _ref.initialRect,
      onScrollElement = _ref.onScrollElement,
      scrollOffsetFn = _ref.scrollOffsetFn,
      _ref$keyExtractor = _ref.keyExtractor,
      keyExtractor = _ref$keyExtractor === void 0 ? defaultKeyExtractor : _ref$keyExtractor,
      _ref$measureSize = _ref.measureSize,
      measureSize = _ref$measureSize === void 0 ? defaultMeasureSize : _ref$measureSize,
      _ref$rangeExtractor = _ref.rangeExtractor,
      rangeExtractor = _ref$rangeExtractor === void 0 ? defaultRangeExtractor : _ref$rangeExtractor;
  var sizeKey = horizontal ? 'width' : 'height';
  var scrollKey = horizontal ? 'scrollLeft' : 'scrollTop';
  var latestRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef({
    scrollOffset: 0,
    measurements: []
  });

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(0),
      scrollOffset = _React$useState[0],
      setScrollOffset = _React$useState[1];

  latestRef.current.scrollOffset = scrollOffset;
  var useMeasureParent = useObserver || useRect;

  var _useMeasureParent = useMeasureParent(parentRef, initialRect),
      outerSize = _useMeasureParent[sizeKey];

  latestRef.current.outerSize = outerSize;
  var defaultScrollToFn = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (offset) {
    if (parentRef.current) {
      parentRef.current[scrollKey] = offset;
    }
  }, [parentRef, scrollKey]);
  var resolvedScrollToFn = scrollToFn || defaultScrollToFn;
  scrollToFn = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (offset) {
    resolvedScrollToFn(offset, defaultScrollToFn);
  }, [defaultScrollToFn, resolvedScrollToFn]);

  var _React$useState2 = react__WEBPACK_IMPORTED_MODULE_0__.useState({}),
      measuredCache = _React$useState2[0],
      setMeasuredCache = _React$useState2[1];

  var measure = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    return setMeasuredCache({});
  }, []);
  var pendingMeasuredCacheIndexesRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef([]);
  var measurements = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    var min = pendingMeasuredCacheIndexesRef.current.length > 0 ? Math.min.apply(Math, pendingMeasuredCacheIndexesRef.current) : 0;
    pendingMeasuredCacheIndexesRef.current = [];
    var measurements = latestRef.current.measurements.slice(0, min);

    for (var i = min; i < size; i++) {
      var key = keyExtractor(i);
      var measuredSize = measuredCache[key];

      var _start = measurements[i - 1] ? measurements[i - 1].end : paddingStart;

      var _size = typeof measuredSize === 'number' ? measuredSize : estimateSize(i);

      var _end = _start + _size;

      measurements[i] = {
        index: i,
        start: _start,
        size: _size,
        end: _end,
        key: key
      };
    }

    return measurements;
  }, [estimateSize, measuredCache, paddingStart, size, keyExtractor]);
  var totalSize = (((_measurements = measurements[size - 1]) == null ? void 0 : _measurements.end) || paddingStart) + paddingEnd;
  latestRef.current.measurements = measurements;
  latestRef.current.totalSize = totalSize;
  var element = onScrollElement ? onScrollElement.current : parentRef.current;
  var scrollOffsetFnRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(scrollOffsetFn);
  scrollOffsetFnRef.current = scrollOffsetFn;
  useIsomorphicLayoutEffect(function () {
    if (!element) {
      setScrollOffset(0);
      return;
    }

    var onScroll = function onScroll(event) {
      var offset = scrollOffsetFnRef.current ? scrollOffsetFnRef.current(event) : element[scrollKey];
      setScrollOffset(offset);
    };

    onScroll();
    element.addEventListener('scroll', onScroll, {
      capture: false,
      passive: true
    });
    return function () {
      element.removeEventListener('scroll', onScroll);
    };
  }, [element, scrollKey]);

  var _calculateRange = calculateRange(latestRef.current),
      start = _calculateRange.start,
      end = _calculateRange.end;

  var indexes = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    return rangeExtractor({
      start: start,
      end: end,
      overscan: overscan,
      size: measurements.length
    });
  }, [start, end, overscan, measurements.length, rangeExtractor]);
  var measureSizeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(measureSize);
  measureSizeRef.current = measureSize;
  var virtualItems = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    var virtualItems = [];

    var _loop = function _loop(k, len) {
      var i = indexes[k];
      var measurement = measurements[i];

      var item = _extends(_extends({}, measurement), {}, {
        measureRef: function measureRef(el) {
          if (el) {
            var measuredSize = measureSizeRef.current(el, horizontal);

            if (measuredSize !== item.size) {
              var _scrollOffset = latestRef.current.scrollOffset;

              if (item.start < _scrollOffset) {
                defaultScrollToFn(_scrollOffset + (measuredSize - item.size));
              }

              pendingMeasuredCacheIndexesRef.current.push(i);
              setMeasuredCache(function (old) {
                var _extends2;

                return _extends(_extends({}, old), {}, (_extends2 = {}, _extends2[item.key] = measuredSize, _extends2));
              });
            }
          }
        }
      });

      virtualItems.push(item);
    };

    for (var k = 0, len = indexes.length; k < len; k++) {
      _loop(k);
    }

    return virtualItems;
  }, [indexes, defaultScrollToFn, horizontal, measurements]);
  var mountedRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  useIsomorphicLayoutEffect(function () {
    if (mountedRef.current) {
      setMeasuredCache({});
    }

    mountedRef.current = true;
  }, [estimateSize]);
  var scrollToOffset = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (toOffset, _temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        _ref2$align = _ref2.align,
        align = _ref2$align === void 0 ? 'start' : _ref2$align;

    var _latestRef$current = latestRef.current,
        scrollOffset = _latestRef$current.scrollOffset,
        outerSize = _latestRef$current.outerSize;

    if (align === 'auto') {
      if (toOffset <= scrollOffset) {
        align = 'start';
      } else if (toOffset >= scrollOffset + outerSize) {
        align = 'end';
      } else {
        align = 'start';
      }
    }

    if (align === 'start') {
      scrollToFn(toOffset);
    } else if (align === 'end') {
      scrollToFn(toOffset - outerSize);
    } else if (align === 'center') {
      scrollToFn(toOffset - outerSize / 2);
    }
  }, [scrollToFn]);
  var tryScrollToIndex = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (index, _temp2) {
    var _ref3 = _temp2 === void 0 ? {} : _temp2,
        _ref3$align = _ref3.align,
        align = _ref3$align === void 0 ? 'auto' : _ref3$align,
        rest = _objectWithoutPropertiesLoose(_ref3, ["align"]);

    var _latestRef$current2 = latestRef.current,
        measurements = _latestRef$current2.measurements,
        scrollOffset = _latestRef$current2.scrollOffset,
        outerSize = _latestRef$current2.outerSize;
    var measurement = measurements[Math.max(0, Math.min(index, size - 1))];

    if (!measurement) {
      return;
    }

    if (align === 'auto') {
      if (measurement.end >= scrollOffset + outerSize) {
        align = 'end';
      } else if (measurement.start <= scrollOffset) {
        align = 'start';
      } else {
        return;
      }
    }

    var toOffset = align === 'center' ? measurement.start + measurement.size / 2 : align === 'end' ? measurement.end : measurement.start;
    scrollToOffset(toOffset, _extends({
      align: align
    }, rest));
  }, [scrollToOffset, size]);
  var scrollToIndex = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // We do a double request here because of
    // dynamic sizes which can cause offset shift
    // and end up in the wrong spot. Unfortunately,
    // we can't know about those dynamic sizes until
    // we try and render them. So double down!
    tryScrollToIndex.apply(void 0, args);
    requestAnimationFrame(function () {
      tryScrollToIndex.apply(void 0, args);
    });
  }, [tryScrollToIndex]);
  return {
    virtualItems: virtualItems,
    totalSize: totalSize,
    scrollToOffset: scrollToOffset,
    scrollToIndex: scrollToIndex,
    measure: measure
  };
}

var findNearestBinarySearch = function findNearestBinarySearch(low, high, getCurrentValue, value) {
  while (low <= high) {
    var middle = (low + high) / 2 | 0;
    var currentValue = getCurrentValue(middle);

    if (currentValue < value) {
      low = middle + 1;
    } else if (currentValue > value) {
      high = middle - 1;
    } else {
      return middle;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

function calculateRange(_ref4) {
  var measurements = _ref4.measurements,
      outerSize = _ref4.outerSize,
      scrollOffset = _ref4.scrollOffset;
  var size = measurements.length - 1;

  var getOffset = function getOffset(index) {
    return measurements[index].start;
  };

  var start = findNearestBinarySearch(0, size, getOffset, scrollOffset);
  var end = start;

  while (end < size && measurements[end].end < scrollOffset + outerSize) {
    end++;
  }

  return {
    start: start,
    end: end
  };
}


//# sourceMappingURL=react-virtual.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [996,85,990,808,703,774,888,179], function() { return __webpack_exec__(7881); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);